import { render } from "./OrderPageList.vue?vue&type=template&id=901f8bb4&scoped=true&ts=true"
import script from "./OrderPageList.vue?vue&type=script&lang=ts"
export * from "./OrderPageList.vue?vue&type=script&lang=ts"

import "./OrderPageList.vue?vue&type=style&index=0&id=901f8bb4&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-901f8bb4"]])

export default __exports__